module.exports = __webpack_public_path__ + "static/media/030.e72794c8.jpg";